import { QuestionInfo } from '@/components/QuestionInfo'
import { Question } from '@/types'
import { getDisabledFlagsByMinAndMax } from '@/utils/getDisabledFlagsByMinAndMax'

import TextField from './molecules/TextField'

type Props = {
  question: Question
}

export const DropdownQuestionRender = ({ question }: Props) => {
  let rangeText = ''
  if (question?.min_value && question?.max_value) {
    rangeText = `You must select between ${question?.min_value} and ${question?.max_value} options`
  } else if (question?.min_value) {
    rangeText = `The minimum required number of selections is ${question?.min_value}`
  } else if (question?.max_value) {
    rangeText = `You can select up to ${question?.max_value} options`
  }

  const { greaterThanMax } = getDisabledFlagsByMinAndMax({
    min: question?.min_value,
    max: question?.max_value,
    total: question.question_choices?.length,
  })

  const isDropdownMultiple =
    question.question_type.question_subtype === 'dropdown_multiple'

  let shouldShowRangeText = false
  if (
    (question?.min_value || question?.max_value) &&
    isDropdownMultiple &&
    !greaterThanMax
  ) {
    shouldShowRangeText = true
  }

  return (
    <div>
      <TextField
        disabled
        isOfficeUse={question.is_office_use_only}
        isRequired={question.is_required}
        label={question.text}
        name={String(question.id)}
        placeholder={`--${question.text}--`}
        value={
          question.question_choices?.find(
            (choice) =>
              choice.id.toString() === question.default_value?.split(',')?.[0]
          )?.text_value
        }
      />
      {shouldShowRangeText ? (
        <QuestionInfo className="mt-2.5">{rangeText}</QuestionInfo>
      ) : null}
    </div>
  )
}
